<div class="breadcrumb-button-container">
  <a class="btn-setting" *ngIf="surveyRecord && allowClone" (click)="cloneSurveyRecord()" title="{{'COMMON_BUTTON_CLONE' | translate}}">
    <i class="icomoon icomoon-clone"></i>
  </a>
  <a class="btn-setting" *ngIf="surveyRecord && allowExport" (click)="downloadPdf()" title="{{'COMMON_BUTTON_EXPORT' | translate}}">
    <i class="icomoon icomoon-export"></i>
  </a>
</div>
